import React from 'react';
import { SPONSORS } from '../data/sponsors';
import { BONUS_SPONSORS } from '../data/sponsors';

export const SponsorMarquee = () => {
  const allSponsors = [...SPONSORS, ...BONUS_SPONSORS];
  const doubled = [...allSponsors, ...allSponsors];

  return (
    <div className="marquee-container" data-testid="sponsor-marquee">
      <div className="marquee-track">
        {doubled.map((sponsor, i) => (
          <a
            key={`${sponsor.id}-${i}`}
            href={sponsor.affiliateUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="marquee-item"
            data-testid="sponsor-marquee-item"
            aria-label={`${sponsor.name} - Yeni sekmede acilir`}
          >
            <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
          </a>
        ))}
      </div>
    </div>
  );
};
